import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { WorkflowService } from '../../services/workflow-service';
import { GlobalService } from '../../services/global.service';
import { AlertComponent } from '../../common/alert/alert.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentDetails } from '../../models/workflow/componentDetails';

@Component({
  selector: 'app-workflow-scheduler',
  templateUrl: './workflow-scheduler.component.html',
  styleUrls: ['./workflow-scheduler.component.css']
})
export class WorkflowSchedulerComponent implements OnInit {

  isLoading: boolean;
  readOnly: boolean;
  workflowTriggerList: any;
  durationTypesList: any;
  dataSourceList: any;
  selectedScheduler: ComponentDetails = new ComponentDetails();
  minDt = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
  maxDt = new Date(new Date().getTime() + (3 * 365 * 24 * 60 * 60 * 1000));
  toMinDt = new Date();
  toMaxDt = new Date(new Date().getTime() + (3 * 365 * 24 * 60 * 60 * 1000));
  displayMode: string = 'add';
  startTimeChanged: boolean;
  public dateTimeRange: Date[];

  public schedulerForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    workflowTriggerTypeId: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    frequency: new UntypedFormControl({ value: '', disabled: true }),
    frequencyUnitId: new UntypedFormControl({ value: '', disabled: true }),
    dataSourceId: new UntypedFormControl({ value: '', disabled: true }),
    startTime: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    endTime: new UntypedFormControl({ value: '', disabled: true }, Validators.required)
  });

  constructor(public dialogRef: MatDialogRef<WorkflowSchedulerComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly workflowService: WorkflowService,
    public globalService: GlobalService, public fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.startTimeChanged = false;
    this.readOnly = this.data.readOnly;
    this.selectedScheduler = this.data.component.componentDetails;
    this.fetchListTimerType();
    if (this.selectedScheduler?.workflowTriggerTypeId > 0) {
      if (this.readOnly) {
        this.displayMode = 'view';
      } else {
        this.displayMode = 'edit';
        this.toMinDt = new Date(this.selectedScheduler.startTime);
      }
      const sTime = new Date(this.selectedScheduler.startTime);
      let localEndTime;
      if (this.globalService.isNotNull(this.selectedScheduler.endTime)) {
        const eTime = new Date(this.selectedScheduler.endTime);
        localEndTime = new Date(eTime.getTime() - (eTime.getTimezoneOffset() * 60000));
      }
      let localStartTime = new Date(sTime.getTime() - (sTime.getTimezoneOffset() * 60000));
      this.schedulerForm = this.fb.group({
        workflowTriggerTypeId: [{ value: this.selectedScheduler.workflowTriggerTypeId, disabled: this.readOnly }, Validators.required],
        frequency: [{ value: this.selectedScheduler.frequency, disabled: this.readOnly }],
        frequencyUnitId: [{ value: this.selectedScheduler.frequencyUnitId, disabled: this.readOnly }],
        dataSourceId: [{ value: this.selectedScheduler.dataSourceId, disabled: this.readOnly }],
        startTime: [{ value: new Date(localStartTime), disabled: this.readOnly }, Validators.required],
        endTime: [{ value: new Date(localEndTime), disabled: this.readOnly }, Validators.required]
      });
      this.checkTriggerType();
    } else {
      this.schedulerForm = this.fb.group({
        workflowTriggerTypeId: ['', Validators.required],
        frequency: [{ value: '', disabled: true }],
        frequencyUnitId: [{ value: '', disabled: true }],
        dataSourceId: [{ value: '', disabled: true }],
        startTime: [{ value: '', disabled: true }, Validators.required],
        endTime: [{ value: '', disabled: true }, Validators.required]
      });
    }
    this.isLoading = false;
  }

  /**Fetcheslist of timer types */
  fetchListTimerType() {
    this.workflowService.getListTimerType().subscribe((data) => {
      this.workflowTriggerList = data;
      this.setMinDt();
      this.isLoading = false;
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }

  /**Triggered when new trigger type is selected */
  onWorkflowTriggerSelected(event) {
    this.isLoading = true;
    this.selectedScheduler.workflowTriggerTypeId = this.schedulerForm.get('workflowTriggerTypeId').value;
    this.schedulerForm.reset();
    this.schedulerForm.patchValue({ workflowTriggerTypeId: this.selectedScheduler.workflowTriggerTypeId });
    this.checkTriggerType();
  }

  checkTriggerType() {
    if (this.schedulerForm.get('workflowTriggerTypeId').value == 1) {
      this.getListFrequencyUnit();
    } else if (this.schedulerForm.get('workflowTriggerTypeId').value == 2) {
      this.getListDataSource();
    }
    else {
      this.ShowManualStartTimer();
     
    }
  }

  getListFrequencyUnit() {
    this.workflowService.getListFrequencyUnit().subscribe((data) => {
      if (!this.readOnly) {
        this.schedulerForm.get('frequency').enable();
        this.schedulerForm.get('frequencyUnitId').enable();
      }
      this.durationTypesList = data;
      this.isLoading = false;
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }
  ShowManualStartTimer() {
    this.schedulerForm.get('startTime').enable();
    this.isLoading = false;
  
  }

  getListDataSource() {
    this.workflowService.getListDataSource().subscribe((data) => {
      this.schedulerForm.get('dataSourceId').enable();
      this.dataSourceList = data['dataSourceList'];
      this.isLoading = false;
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }
  
  onDurationTypeSelected(event) {
    if (this.schedulerForm.get('workflowTriggerTypeId').value == 1) {
      this.selectedScheduler.frequency = this.schedulerForm.get('frequency').value;
      this.selectedScheduler.frequencyUnitId = this.schedulerForm.get('frequencyUnitId').value;
    } else {
      this.selectedScheduler.dataSourceId = this.schedulerForm.get('dataSourceId').value;
    }
    
    this.schedulerForm.get('startTime').enable();
    this.schedulerForm.get('endTime').enable();
  }

  saveSchedulerDetails() {
    this.data.component.componentDetails.id = 99999;
    this.data.component.componentDetails.workflowTriggerTypeId = this.schedulerForm.get('workflowTriggerTypeId').value;
    if (this.schedulerForm.get('workflowTriggerTypeId').value == 1) {
      this.data.component.componentDetails.frequency = this.schedulerForm.get('frequency').value;
      this.data.component.componentDetails.frequencyUnitId = this.schedulerForm.get('frequencyUnitId').value;
    } else {
      this.data.component.componentDetails.dataSourceId = this.schedulerForm.get('dataSourceId').value;
    }
    let sDate = new Date(this.schedulerForm.get('startTime').value.setSeconds(0));
    this.selectedScheduler.startTime = sDate.toString();
    this.data.component.componentDetails.startTime = sDate; 
    if (this.displayEndTime()) {
      let eDate = new Date(this.schedulerForm.get('endTime').value.setSeconds(0));
      this.selectedScheduler.endTime = eDate.toString();
      this.data.component.componentDetails.endTime = eDate;
    } else {
      this.selectedScheduler.endTime = "";
      this.data.component.componentDetails.endTime = "";
    }
    this.dialogRef.close(false);
  }

  disableAddBtn() {
    let check: boolean = this.globalService.isNotNullObject(this.schedulerForm) && this.schedulerForm.get('workflowTriggerTypeId').valid &&
      ((this.schedulerForm.get('workflowTriggerTypeId').value == 1 && this.schedulerForm.get('frequency').valid &&
        this.schedulerForm.get('frequencyUnitId').valid) ||
        (this.schedulerForm.get('workflowTriggerTypeId').value == 2 && this.schedulerForm.get('dataSourceId').valid)
      || this.schedulerForm.get('workflowTriggerTypeId').value == 3
      );
    return !check;
  }

  /**Closes the dialog box */
  onCancelClick() {
    this.dialogRef.close(false);
  }

  startTimeChange() {
    if (['edit', 'add'].includes(this.displayMode)) {
      this.startTimeChanged = true;
    }
  }

  updateEndDate(startDate) {
    this.toMinDt = new Date(startDate._selected.toString());
    this.toMaxDt = new Date(this.toMinDt.getTime() + (3 * 365 * 24 * 60 * 60 * 1000));
  }

  /**Displays end time if start time selected is a time in the past*/
  displayEndTime() {
    let check: boolean;
    if (this.schedulerForm.get('workflowTriggerTypeId').value == 2 || this.schedulerForm.get('workflowTriggerTypeId').value == 3) {
      check = false;
    } else if (!this.startTimeChanged && ['view', 'edit'].includes(this.displayMode)) {
      check = this.globalService.isNotNull(this.selectedScheduler.endTime) && (new Date(this.schedulerForm.get('startTime').value)).getTime() < (new Date()).getTime();
    } else {
      check = (new Date(this.schedulerForm.get('startTime').value)).getTime() < (new Date()).getTime();
    }
    return check;
  }

  setMinDt() {
    let d = new Date();
    if (this.schedulerForm.get('workflowTriggerTypeId').value == this.workflowTriggerList[0].timerTypeId) {
      this.minDt = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
    } else {
      this.minDt.setMonth(d.getMonth());
    }
    this.minDt.setDate(this.minDt.getDate());
  }

}
